import { createResource } from '@atlassian/react-resource-router';

export const epicsLiteResource = createResource({
	type: 'EPICS_LITE_PRELOAD',
	getKey: ({ match }) => match.params.boardId || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-epics-lite", jiraSpaEntry: "async-epics-lite" */ './get-data'
		),
	maxAge: 0,
});
